/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expFactor = 3;
window.lazySizesConfig.lazyClass = "jsLazy";
